import { Box, ButtonBS, Center, Heading, Stack, useBreakpointValue } from "@biblioteksentralen/react";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { getPath, ResolvedList } from "@libry-content/common";
import { Edit } from "../editInSanity/EditInSanity";
import ItemGrid from "../../searchAndCollection/components/works/ItemGrid";
import InternalLink from "../InternalLink";

interface Props {
  list?: ResolvedList;
}

// "Lite-versjon" av BookListView-komponenten, ment å vise listetittel og første tre elementene i listen, samt lenke til listen.
const SommerlesBooklistPreview = ({ list }: Props) => {
  const { t, ts } = useTranslation();

  const publicationsToShow = useBreakpointValue({ base: 3, md: list?.items && list.items.length > 3 ? 4 : 2, lg: 3 });

  if (!list) return null;

  return (
    <Box>
      <Stack gridGap="1.5rem" maxWidth="35rem">
        <Stack>
          <Heading as="h3" fontSize={{ base: "xl", md: "2xl" }}>
            {ts(list.title)}
          </Heading>
        </Stack>
      </Stack>

      <Stack direction="column" paddingBottom="2rem" gap="2rem">
        <Edit doc={list} />
        <ItemGrid
          items={list.items?.slice(0, publicationsToShow)}
          headingSize="h2"
          showPublicationTeaser={list.publicationTeaserToggle}
        />
      </Stack>
      <Center width="100%" zIndex="1">
        <ButtonBS as={InternalLink} variant="secondary" textDecoration="none" href={getPath(list)}>
          {t("Se hele listen")}
        </ButtonBS>
      </Center>
    </Box>
  );
};

export default SommerlesBooklistPreview;
